import styled from 'styled-components';

import theme from '$/assets/theme';

const StyledCheckmark = styled.span<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  background: transparent;
  border: 2px solid
    ${(props) =>
      props.error ? theme.colors.functionalRed : theme.colors.grey8};
  box-sizing: border-box;
  border-radius: 2px;

  transition: all 200ms;

  &:after {
    content: '';
    width: 5px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    opacity: 0;
    transition: all 200ms;
    margin-top: -4px;
  }
`;

export default StyledCheckmark;
